import FullTextLogo from "./FullTextLogo";
import LogoOnly from "./LogoOnly";
import React from "react";
import { createUseStyles } from "react-jss";
import { eventTypes } from "../../../../lib/analytics";

const HYRO_HOMEPAGE = "https://www.hyro.ai";

const useStyles = createUseStyles({
  button: {
    cursor: "pointer",
    cssFloat: "right",
    border: "1px none transparent",
    backgroundColor: "transparent",
  },
});

export default ({ type, sendEvent }) => {
  const styles = useStyles();
  const logoTypes = { fullText: <FullTextLogo />, logoOnly: <LogoOnly /> };
  return (
    <button
      className={styles.button}
      onClick={() => {
        sendEvent(eventTypes.POWERED_BY_HYRO_CLICK);
        window.open(HYRO_HOMEPAGE, "_blank");
      }}
    >
      {logoTypes[type]}
    </button>
  );
};
